import { NavLink, Link, useNavigate } from 'react-router-dom'
import { useTheme } from '../context/ThemeProvider'
import { useState, useEffect } from 'react'
import {
  faBars,
  faRightFromBracket,
  faUser,
  faHouse,
  faCommentMedical,
  faSchool,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Nav from '../components/Admin/Nav'
import useLogout from '../hooks/useLogout'
const navClasses =
  'w-full text-portal-dark-purple p-1 flex relative rounded-md items-center'

function LeftBar({ collapsed, toggleSidebar, isImpersonating }) {
  const navigate = useNavigate()
  const logout = useLogout()
  const theme = useTheme()
  const logo = theme?.logo
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'auto'
    return () => (document.body.style.overflow = 'auto')
  }, [isMobileMenuOpen])

  return (
    <>
      {/* DESKTOP SIDEBAR */}
      <aside
        style={{ marginTop: isImpersonating ? "65px" : "0" }}
        className={`hidden lg:block fixed inset-0 z-50 mb-4 h-[calc(100vh-32px)] w-40 pl-4 ${collapsed ? 'hidden' : 'block'
          }`}
      >
        <div className="relative border-b border-b-[#A392A5] w-full flex justify-center">
          <Link to="/" className="">
            {logo ? (
              <img src={logo} alt="Logo" className="h-16 my-4 mx-2" />
            ) : (
              <span className="font-bold text-lg">Logo</span>
            )}
          </Link>
        </div>
        <div className="w-full flex flex-col relative h-[calc(100%-100px)]">
          <ul className="flex flex-col gap-0 mt-4 overflow-y-auto flex-1 pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            <Nav />

            {/* Profile and Logout moved into scrollable area */}
            <li className="mt-4 border-t border-t-[#A392A5] pt-4">
              <NavLink
                to="/my-profile"
                className={({ isActive }) =>
                  (isActive ? 'bg-nav-item-active shadow-inner-lg ' : '') +
                  navClasses +
                  ' flex flex-col items-center gap-1 hover:text-nav-dark py-6 '
                }
              >
                <FontAwesomeIcon icon={faUser} className="text-xl" />
                <div>Profile</div>
              </NavLink>
            </li>
            <li className="text-portal-dark-purple flex justify-center pb-4">
              <button
                onClick={logout}
                className="flex flex-col items-center gap-1 hover:text-nav-dark py-3"
              >
                <FontAwesomeIcon
                  icon={faRightFromBracket}
                  className="text-xl"
                />
                <div>Logout</div>
              </button>
            </li>
          </ul>
        </div>
      </aside>

      {/* MOBILE BOTTOM NAVIGATION */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-t border-gray-100 shadow-2xl">
        <div className="flex items-center justify-around px-2 py-3 max-w-md mx-auto gap-x-8">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-0 px-3 py-2 rounded-xl transition-all duration-200 ${isActive
                ? 'bg-gradient-to-br from-nav-item-active to-[#A892B5] text-white shadow-lg transform scale-105'
                : 'text-gray-600 hover:text-[#8B5A9B] hover:bg-gray-50'
              }`
            }
          >
            <FontAwesomeIcon
              icon={faHouse}
              className={`text-lg mb-1 ${({ isActive }) =>
                isActive ? 'text-white' : ''}`}
            />
            <span className="text-xs font-medium">Home</span>
          </NavLink>

          <NavLink
            to="/referrals"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-0 px-3 py-2 rounded-xl transition-all duration-200 ${isActive
                ? 'bg-gradient-to-br from- to-[#A892B5] text-white shadow-lg transform scale-105'
                : 'text-gray-600 hover:text-[#8B5A9B] hover:bg-gray-50'
              }`
            }
          >
            <FontAwesomeIcon
              icon={faCommentMedical}
              className={`text-lg mb-1 ${({ isActive }) =>
                isActive ? 'text-white' : ''}`}
            />
            <span className="text-xs font-medium">Referrals</span>
          </NavLink>

          <NavLink
            to="/my-school"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-0 px-3 py-2 rounded-xl transition-all duration-200 ${isActive
                ? 'bg-gradient-to-br from-[#BCA6C4] to-[#A892B5] text-white shadow-lg transform scale-105'
                : 'text-gray-600 hover:text-[#8B5A9B] hover:bg-gray-50'
              }`
            }
          >
            <FontAwesomeIcon
              icon={faSchool}
              className={`text-lg mb-1 ${({ isActive }) =>
                isActive ? 'text-white' : ''}`}
            />
            <span className="text-xs font-medium">School</span>
          </NavLink>

          <NavLink
            to="/my-profile"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-0 px-3 py-2 rounded-xl transition-all duration-200 ${isActive
                ? 'bg-gradient-to-br from-[#BCA6C4] to-[#A892B5] text-white shadow-lg transform scale-105'
                : 'text-gray-600 hover:text-[#8B5A9B] hover:bg-gray-50'
              }`
            }
          >
            <FontAwesomeIcon
              icon={faUser}
              className={`text-lg mb-1 ${({ isActive }) =>
                isActive ? 'text-white' : ''}`}
            />
            <span className="text-xs font-medium">Profile</span>
          </NavLink>
        </div>
      </nav>

      {/* <div className="lg:hidden absolute top-4 left-0 right-0 z-50 px-4 flex items-center justify-between">
        <a href='/'>
          <img src={logo} alt="SWB Logo" className="h-10" />
        </a>
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="text-2xl text-portal-dark-purple"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div> */}

      {/* MOBILE DROPDOWN */}
      {/* {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-16 right-2 z-50 bg-white rounded-lg shadow-xl border border-gray-100 px-4 py-4 space-y-4">
          <div className="mb-2">
            <NavLink
              to="/"
              className={({ isActive }) =>
                (isActive ? ' bg-[#BCA6C4] shadow-inner-lg px-4 py-2 ' : '') +
                navClasses +
                ' flex items-center space-x-2 hover:text-nav-dark'
              }
            >
              <FontAwesomeIcon icon={faHouse} className="text-xl" />
              <div>Home</div>
            </NavLink>
          </div>
          <div className="mb-2">
            <NavLink
              to="/referrals"
              className={({ isActive }) =>
                (isActive ? ' bg-[#BCA6C4] shadow-inner-lg px-4 p-2 ' : '') +
                navClasses +
                ' flex items-center space-x-2 hover:text-nav-dark'
              }
            >
              <FontAwesomeIcon icon={faCommentMedical} className="text-xl" />
              <div>My Referrals</div>
            </NavLink>
          </div>

          <div className="mb-2 text-portal-dark-purple">
            <NavLink
              to="/my-school"
              className={({ isActive }) =>
                (isActive ? ' bg-[#BCA6C4] shadow-inner-lg px-4 py-2 ' : '') +
                navClasses +
                ' flex items-center space-x-2 hover:text-nav-dark'
              }
            >
              <FontAwesomeIcon icon={faSchool} className="text-xl" />
              <div>My School</div>
            </NavLink>
          </div>
          <NavLink
            to="/my-profile"
            className={({ isActive }) =>
              (isActive ? 'text-nav-dark ' : '') +
              navClasses +
              ' flex items-center gap-2 hover:text-nav-dark'
            }
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FontAwesomeIcon icon={faUser} />
            <span>Profile</span>
          </NavLink>

          <button
            onClick={() => {
              setIsMobileMenuOpen(false)
              handleLogout()
            }}
            className="flex items-center gap-2 text-portal-dark-purple hover:text-nav-dark"
          >
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Logout</span>
          </button>
        </div>
      )} */}
    </>
  )
}

export default LeftBar
